// temp component
// todo: replace with design system component when available
import { Textarea } from '@finn/design-system/atoms/textarea';
import { useIntl } from '@finn/ui-utils';
import React from 'react';
import { Controller, useFormContext, UseFormReturn } from 'react-hook-form';

type Props = {
  name: string;
  placeholder?: string;
  form?: UseFormReturn<any>;
  className?: string;
};

export const HookFormTextarea: React.FC<Props> = ({
  name,
  placeholder,
  form,
  className,
}) => {
  const i18n = useIntl();
  const { control, formState } = useFormContext();
  const { errors } = formState || {};

  return (
    <Controller
      control={form?.control ?? control}
      name={name}
      render={({ field }) => (
        <Textarea
          {...field}
          placeholder={placeholder}
          className={className}
          rows={5}
          error={
            errors[name] ? i18n.formatMessage(errors[name].message) : undefined
          }
        />
      )}
    />
  );
};
